import { useState } from "react";
import feedbackIcon from "../../../feedback.png";
import FeedbackModal from "./FeedbackModal";

const FeedbackBtn = () => {
    const [showFeedbackModal, setShowFeedbackModal] = useState(false);

    return (
        <>
            <a href="#" onClick={e => {e.preventDefault(); setShowFeedbackModal(!showFeedbackModal)}}>
                <img style={{marginTop: 7}} src={feedbackIcon} alt="" width={32} />
            </a>

            <FeedbackModal show={showFeedbackModal} setShow={setShowFeedbackModal} />
        </>
    )
}
export default FeedbackBtn;